import CookiesJS from 'cookies-js';

export function initSimilarRecipes($, apiClient) {
    $('form.similar-recipes-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const similarRecipes = [];
            $('#similar-recipes .array-item .similar-recipe-checkbox').each(function () {
                if (!!$(this).prop('checked')) {
                    similarRecipes.push($(this).attr('data-recipe-id'));
                }
            });
            const recipe = {
                similarRecipes
            };
            const result = await apiClient.updateOne('/recipes', _id, recipe, CookiesJS.get('auth_token'));
            console.log(result);
            alert('Сохранено');
            location.reload();
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
